/**
 * PJ Gaming Store — Main JS
 */
(function () {
  'use strict';

  const $ = (s, ctx = document) => ctx.querySelector(s);
  const $$ = (s, ctx = document) => [...ctx.querySelectorAll(s)];
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  /* Escape obbligatorio per ogni valore che finisce in una stringa HTML: i dati del carrello
     arrivano dall'API Shopify e quindi dal catalogo, che e' scritto anche dalle app installate.
     Senza questo, un titolo prodotto con del markup dentro verrebbe eseguito nella pagina. */
  const escHtml = (v) => String(v == null ? '' : v)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

  /* ── Toast ── */
  function toast(msg, type = 'success', ms = 3500) {
    let c = $('#pjToastContainer');
    if (!c) { c = document.createElement('div'); c.id = 'pjToastContainer'; c.className = 'pj-toast-container'; document.body.appendChild(c); }
    const el = document.createElement('div');
    el.className = `pj-toast pj-toast--${type}`;
    el.innerHTML = `<span>${type === 'success' ? '✓' : '✗'}</span> `;
    el.appendChild(document.createTextNode(msg));
    c.appendChild(el);
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('show')));
    setTimeout(() => { el.classList.remove('show'); setTimeout(() => el.remove(), 400); }, ms);
  }

  /* ── Header scroll ── */
  const header = $('#masthead');
  if (header) {
    window.addEventListener('scroll', debounce(() => {
      header.classList.toggle('scrolled', scrollY > 50);
    }, 50), { passive: true });
  }

  /* ── Mobile Menu ── */
  const hamburger = $('#hamburgerBtn');
  const mobileMenu = $('#mobileMenu');
  const mobileOverlay = $('#mobileMenuOverlay');
  const mobileClose = $('#mobileMenuClose');

  function openMobileMenu() {
    mobileMenu?.classList.add('open');
    mobileOverlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenu?.classList.remove('open');
    mobileOverlay?.classList.remove('active');
    document.body.style.overflow = '';
  }

  hamburger?.addEventListener('click', openMobileMenu);
  mobileClose?.addEventListener('click', closeMobileMenu);
  mobileOverlay?.addEventListener('click', closeMobileMenu);

  $$('.mobile-menu__submenu-toggle').forEach(btn => {
    btn.addEventListener('click', function () {
      const li = this.closest('.mobile-menu__item');
      const sub = li.querySelector('.mobile-menu__submenu');
      if (sub) {
        const open = sub.style.display === 'block';
        sub.style.display = open ? 'none' : 'block';
        this.setAttribute('aria-expanded', !open);
      }
    });
  });

  /* ── Mini Cart ── */
  const cartTrigger = $('#cartTrigger');
  const cartDrawer = $('#miniCartDrawer');
  const cartOverlay = $('#miniCartOverlay');
  const cartClose = $('#miniCartClose');

  function openMiniCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('active');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  function closeMiniCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('active');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartTrigger?.addEventListener('click', openMiniCart);
  cartClose?.addEventListener('click', closeMiniCart);
  cartOverlay?.addEventListener('click', closeMiniCart);

  /* Esposto per la pagina prodotto: aggiornare/aprire il mini-cart dopo un'aggiunta (anche con upgrade Globo) */
  window.pjCart = {
    refresh: () => refreshCartDrawer(),
    open: () => openMiniCart(),
    count: (n) => updateCartCount(n)
  };

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeMobileMenu(); closeMiniCart(); }
  });

  /* ── Cart API ── */
  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Errore aggiunta al carrello');
    return res.json();
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function removeCartItem(key) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    return res.json();
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function updateCartCount(count) {
    $$('.mini-cart-count').forEach(el => { el.textContent = count; });
  }

  async function refreshCartDrawer() {
    const body = $('#miniCartBody');
    if (!body) return;
    const cart = await getCart();
    updateCartCount(cart.item_count);
    if (cart.item_count === 0) {
      body.innerHTML = `<div class="mini-cart-empty"><div class="mini-cart-empty__icon">🛒</div><p>Il tuo carrello e vuoto.</p></div>`;
      const footer = $('#miniCartFooter');
      if (footer) footer.style.display = 'none';
      return;
    }
    const footer = $('#miniCartFooter');
    if (footer) footer.style.display = 'block';
    body.innerHTML = cart.items.map(item => `
      <div class="mini-cart-item" data-key="${escHtml(item.key)}">
        <img class="mini-cart-item__img" src="${escHtml(item.image || '')}" alt="${escHtml(item.product_title)}" loading="lazy">
        <div class="mini-cart-item__info">
          <div class="mini-cart-item__title">${escHtml(item.product_title)}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="mini-cart-item__qty">${escHtml(item.variant_title)}</div>` : ''}
          <div class="mini-cart-item__price">${formatMoney(item.final_line_price)}</div>
          <div class="mini-cart-item__qty">Qta: ${Number(item.quantity) || 0}</div>
        </div>
        <button class="mini-cart-item__remove" data-key="${escHtml(item.key)}" aria-label="Rimuovi">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
    `).join('');
    const total = $('#miniCartTotal');
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.mini-cart-item__remove');
    if (!btn) return;
    const key = btn.dataset.key;
    btn.closest('.mini-cart-item').style.opacity = '0.4';
    await removeCartItem(key);
    await refreshCartDrawer();
  });

  /* ── Add to Cart (product cards) ── */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.btn-add-to-cart[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('loading')) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.classList.add('loading');
    const orig = btn.innerHTML;
    btn.innerHTML = '...';
    try {
      await addToCart(variantId, 1);
      const cart = await getCart();
      updateCartCount(cart.item_count);
    } catch (err) {
      toast('Errore. Riprova.', 'error');
    } finally {
      btn.classList.remove('loading');
      btn.innerHTML = orig;
    }
  });

  /* ── Quantity Buttons ── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const input = btn.closest('.qty-wrap')?.querySelector('.qty-input');
    if (!input) return;
    let val = parseFloat(input.value) || 1;
    const min = parseFloat(input.min) || 1;
    const max = parseFloat(input.max) || 999;
    if (btn.dataset.dir === 'up') val = Math.min(max, val + 1);
    if (btn.dataset.dir === 'down') val = Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Product Page Tabs ── */
  $$('.product-tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      $$('.product-tab-btn').forEach(b => b.classList.remove('active'));
      $$('.product-tab-panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      $(`#${btn.dataset.tab}`)?.classList.add('active');
    });
  });

  /* ── Back to Top ── */
  const btt = $('#backToTop');
  window.addEventListener('scroll', debounce(() => {
    btt?.classList.toggle('visible', scrollY > 400);
  }, 100), { passive: true });
  btt?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

  /* ── Scroll Animations ── */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    $$('.product-card, .category-card, .section-header').forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = `opacity 0.4s ease ${i * 0.04}s, transform 0.4s ease ${i * 0.04}s`;
      observer.observe(el);
    });
  }

  /* ── Countdown (promo banner) ── */
  const cdH = $('#cdHours'), cdM = $('#cdMins'), cdS = $('#cdSecs');
  if (cdH) {
    const end = new Date(); end.setHours(24, 0, 0, 0);
    function updateCd() {
      const left = Math.max(0, end - Date.now());
      cdH.textContent = String(Math.floor(left / 3600000)).padStart(2, '0');
      cdM.textContent = String(Math.floor((left % 3600000) / 60000)).padStart(2, '0');
      cdS.textContent = String(Math.floor((left % 60000) / 1000)).padStart(2, '0');
    }
    updateCd();
    setInterval(updateCd, 1000);
  }

  /* ── Tabella FPS: righe = giochi, colonne = risoluzioni, filtro preset (card + pagina prodotto) ── */
  function updateFpsWidget(widget) {
    // Le risoluzioni sono COLONNE e restano sempre tutte visibili: l'unico filtro e' il preset.
    // Per ogni cella si cercano i valori della SUA risoluzione al preset attivo; se quella
    // combinazione non esiste la cella mostra un trattino, e la riga si nasconde solo quando il
    // gioco non ha alcun dato al preset attivo (mai numeri di un preset diverso da quello indicato).
    const activePreset = widget.querySelector('.fps-filter-btn[data-dim="preset"].is-active');
    const hasPresetSwitch = !!widget.querySelector('.fps-filter-btn[data-dim="preset"]');
    const presetVal = activePreset ? activePreset.dataset.val : null;
    let visible = 0;
    $$('.fps-row', widget).forEach(row => {
      let data = {};
      try { data = JSON.parse(row.dataset.fps || '{}'); } catch (err) { data = {}; }
      let rowHasAny = false;
      $$('.fps-cell', row).forEach(cell => {
        const byRes = data[cell.dataset.res] || null;
        const presetKey = hasPresetSwitch ? presetVal : (byRes ? Object.keys(byRes)[0] : null);
        const entry = (byRes && presetKey) ? byRes[presetKey] : null;
        const numEl = cell.querySelector('.fps-cell__num');
        const rangeEl = cell.querySelector('.fps-cell__range');
        if (entry) {
          if (numEl) numEl.textContent = entry.avg;
          if (rangeEl) rangeEl.textContent = entry.min + '–' + entry.max;
          cell.classList.remove('is-void');
          rowHasAny = true;
        } else {
          if (numEl) numEl.textContent = '—';
          if (rangeEl) rangeEl.textContent = '';
          cell.classList.add('is-void');
        }
      });
      row.classList.toggle('is-hidden', !rowHasAny);
      if (rowHasAny) visible++;
    });
    // niente dati per il preset scelto: si nasconde la tabella (intestazioni comprese) e si spiega perche'
    const empty = widget.querySelector('.fps-empty-msg');
    if (empty) empty.style.display = visible === 0 ? 'block' : 'none';
    const table = widget.querySelector('.fps-table');
    if (table) table.style.display = visible === 0 ? 'none' : '';
    const legend = widget.querySelector('.fps-legend');
    if (legend) legend.style.display = visible === 0 ? 'none' : '';
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.fps-filter-btn');
    if (!btn) return;
    if (btn.classList.contains('fps-filter-btn--static')) return; // chip di sola indicazione: lascia passare il click alla card
    const widget = btn.closest('[data-fps-widget]');
    if (!widget) return;
    // Nelle card (categoria/slider/banner) il widget sta DENTRO <a class="product-card__link">:
    // senza questo il click sul bottone risalirebbe al link e aprirebbe la pagina prodotto.
    // Annullato solo per i bottoni di cambio risoluzione/preset: il resto della card resta cliccabile.
    e.preventDefault();
    e.stopPropagation();
    const dim = btn.dataset.dim;
    $$(`.fps-filter-btn[data-dim="${dim}"]`, widget).forEach(b => b.classList.toggle('is-active', b === btn));
    updateFpsWidget(widget);
  });

  // Allineamento iniziale: garantisce che i valori mostrati corrispondano sempre
  // alle etichette risoluzione/preset attive, anche se il markup arriva da cache.
  $$('[data-fps-widget]').forEach(updateFpsWidget);

  /* ── Frecce di scorrimento per gli slider prodotti (visibili su mobile/tablet via CSS) ── */
  function initSliderArrows(scroller) {
    const track = scroller.querySelector('.product-slider-track');
    if (!track || scroller.parentElement?.classList.contains('pj-slider-wrap')) return;

    // Wrapper posizionato: le frecce devono stare FUORI dall'area che scorre,
    // altrimenti scorrerebbero via insieme alle card.
    const wrap = document.createElement('div');
    wrap.className = 'pj-slider-wrap';
    scroller.parentNode.insertBefore(wrap, scroller);
    wrap.appendChild(scroller);

    const makeArrow = (dir, label, points) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `pj-slider-arrow pj-slider-arrow--${dir}`;
      b.setAttribute('aria-label', label);
      b.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="${points}"/></svg>`;
      wrap.appendChild(b);
      return b;
    };
    const prev = makeArrow('prev', 'Prodotti precedenti', '15 18 9 12 15 6');
    const next = makeArrow('next', 'Prodotti successivi', '9 6 15 12 9 18');

    // Avanza di una card alla volta (larghezza card + gap), così non si perde il filo.
    const step = () => {
      const item = track.querySelector('.product-slider-item');
      const cs = getComputedStyle(track);
      const gap = parseFloat(cs.columnGap || cs.gap) || 0;
      const w = item ? item.getBoundingClientRect().width : 0;
      return w ? w + gap : Math.round(scroller.clientWidth * 0.8);
    };
    // pos opzionale: con lo scorrimento morbido scrollLeft cambia in modo graduale,
    // quindi al click si aggiorna subito lo stato usando la posizione di ARRIVO.
    const sync = (pos) => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const at = typeof pos === 'number' ? Math.max(0, Math.min(max, pos)) : scroller.scrollLeft;
      wrap.classList.toggle('has-overflow', max > 4);
      prev.classList.toggle('is-disabled', at <= 2);
      next.classList.toggle('is-disabled', at >= max - 2);
    };
    const go = (dir) => {
      const delta = dir * step();
      scroller.scrollBy({ left: delta, behavior: 'smooth' });
      sync(scroller.scrollLeft + delta);
    };

    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    scroller.addEventListener('scroll', debounce(sync, 60), { passive: true });
    window.addEventListener('resize', debounce(sync, 150));
    window.addEventListener('load', sync);
    sync();
  }
  $$('.product-slider-container').forEach(initSliderArrows);

  console.log('%c🎮 PJ Gaming Store — Ready', 'color:#fcc907;font-family:monospace;font-size:14px;');
})();